import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "tw"
};
const _hoisted_2 = {
  key: 2,
  class: "py-2 pt-4"
};
const _hoisted_3 = {
  class: "py-2"
};
const _hoisted_4 = {
  key: 0,
  class: "alert alert-warning mx-1"
};
const _hoisted_5 = {
  key: 1,
  class: "alert alert-info mb-2 mx-1"
};
const _hoisted_6 = {
  key: 2,
  class: "alert alert-error mb-2 mx-1"
};
const _hoisted_7 = {
  key: 3,
  class: "alert alert-error"
};
import { onMounted, reactive, computed, ref, onUnmounted } from 'vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore';
import useClientMatterStore from '@/services/useClientMatterStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSelect from '@/components/LlSelect.vue';
import { useInvoiceActions } from './../useInvoiceActions';
import axios from 'axios';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { useMatterUserManagement } from '@/composables/useMatterUserManagement';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export default {
  __name: 'MatterChangeLineItem',
  emits: ['cancel', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const meStore = useMeStore();
    const invoiceState = useInvoiceState();
    const invoiceEditorStore = useInvoiceEditorStore();
    const clientMatterStore = useClientMatterStore();
    const {
      userMessages,
      checkMissingUsersAndGenerateMessages,
      generateUserAdditionMessages,
      clearCache
    } = useMatterUserManagement();
    const {
      handleError
    } = useSnackbarHandler();
    const {
      selectedLineItem
    } = invoiceEditorStore;
    const {
      changeMatterForLineItem,
      changeMatterForGroup
    } = useInvoiceActions();
    const confirmDialog = ref(null);
    const cmQueryFilter = computed(() => {
      return {
        scopeAccount: null,
        originating: false,
        involved: false,
        reviewer: false,
        primary: false,
        archived: false
      };
    });
    const matterChangeState = reactive({
      me: {},
      draftInvoice: null,
      draftInvoices: [],
      selectionValid: true,
      loadingDraftInvoiceList: false,
      client: null,
      matter: null,
      loadingClientMatter: false,
      unableToMoveChargeWithBilledEntries: false,
      userAddedMessages: [],
      hasMissingUsers: false,
      loadingUserValidation: false
    });
    const emit = __emit;
    const {
      groups
    } = invoiceState;
    let _accountIds = [];
    onMounted(async () => {
      matterChangeState.loadingClientMatter = true;
      matterChangeState.me = await meStore.getMe();
      _accountIds = Object.keys(groups.reduce((list, group) => {
        group.lineItems.filter(li => li.account && li.checked).forEach(li => {
          list[li.account.id] = true;
        });
        return list;
      }, {}));
      if (selectedLineItem.charges) {
        await checkChargeForBilledEntries();
      }
      if (Object.keys(selectedLineItem).length) {
        let matterId = '';
        if (selectedLineItem.entries) {
          matterId = selectedLineItem.entries[0].matter.id;
        } else if (selectedLineItem.expenses) {
          matterId = selectedLineItem.expenses[0].matter.id;
        } else if (selectedLineItem.charges) {
          matterId = selectedLineItem.charges[0].matter.id;
        }
        matterChangeState.matter = await clientMatterStore.getMatterWithClientById(matterId);
        matterChangeState.client = matterChangeState.matter?.client;
        draftInvoiceList({
          matterId: matterChangeState.matter?.id,
          clientId: matterChangeState.matter?.client?.id,
          timeSheetId: invoiceState.id
        });
        matterChangeState.loadingClientMatter = false;
      }
      matterChangeState.loadingClientMatter = false;
    });

    // Add cleanup when component unmounts
    onUnmounted(() => {
      clearCache();
    });
    async function checkChargeForBilledEntries() {
      let anyBilledEntries = false;
      let chargeId = selectedLineItem.charges[0].id;
      let {
        data
      } = await axios.get(`/entries/charge/${chargeId}`);
      let entries = data;
      entries.forEach(entry => {
        if (entry.timeSheetId?.id && entry.timeSheetId.id !== invoiceState.id) {
          anyBilledEntries = true;
        }
      });
      matterChangeState.unableToMoveChargeWithBilledEntries = anyBilledEntries;
    }
    async function draftInvoiceList(params) {
      matterChangeState.loadingDraftInvoiceList = true;
      try {
        const draftInvoices = await invoiceEditorStore.draftInvoiceList(params);

        // Get the original matter ID from the selected line item
        let originalMatterId = '';
        if (selectedLineItem.entries) {
          originalMatterId = selectedLineItem.entries[0]?.matter?.id;
        } else if (selectedLineItem.expenses) {
          originalMatterId = selectedLineItem.expenses[0]?.matter?.id;
        } else if (selectedLineItem.charges) {
          originalMatterId = selectedLineItem.charges[0]?.matter?.id;
        }

        // If the selected line item's matter is the same as the newly selected matter,
        // filter out the current invoice from the dropdown
        if (originalMatterId === params.matterId) {
          matterChangeState.draftInvoices = draftInvoices.filter(invoice => invoice.timeSheetId !== invoiceState.id);
        } else {
          matterChangeState.draftInvoices = draftInvoices;
        }
      } finally {
        matterChangeState.loadingDraftInvoiceList = false;
      }
    }
    const matterChanged = async () => {
      matterChangeState.draftInvoices = [];
      matterChangeState.draftInvoice = null;
      matterChangeState.userAddedMessages = [];
      matterChangeState.loadingUserValidation = false;
      if (matterChangeState.matter) {
        matterChangeState.loadingUserValidation = true;
        try {
          // Check for missing users using the correct function name
          const result = await checkMissingUsersAndGenerateMessages(matterChangeState.matter.id, _accountIds, selectedLineItem, groups);

          // Update state with validation results
          matterChangeState.hasMissingUsers = result.hasMissingUsers;
          matterChangeState.userAddedMessages = result.messages;

          // Fetch draft invoices with proper filtering
          await draftInvoiceList({
            matterId: matterChangeState.matter.id,
            clientId: matterChangeState.matter.clientId,
            timeSheetId: invoiceState.id
          });
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || 'An error occurred while validating the matter change.';
          handleError(errorMessage);
        } finally {
          matterChangeState.loadingUserValidation = false;
        }
      }
    };
    const verifyMatterChange = () => {
      let selectedItems = [];
      groups.forEach(g => {
        g.lineItems.forEach(li => {
          if (li.checked) {
            selectedItems.push(li);
          }
        });
      });
      if (selectedItems.some(li => li.entries?.some(e => e.chargeId))) {
        confirmDialog.value.open().then(async result => {
          if (result) {
            matterClientChange();
          } else {
            emit('cancel');
          }
        });
      } else {
        matterClientChange();
      }
    };
    const matterClientChange = async () => {
      try {
        await generateUserAdditionMessages(matterChangeState.matter.id, _accountIds, selectedLineItem, groups);

        // Update the local messages with the composable messages
        matterChangeState.userAddedMessages = [...userMessages.value];
        if (Object.keys(selectedLineItem).length) {
          await changeMatterForLineItem({
            lineItem: selectedLineItem,
            matterId: matterChangeState.matter.id,
            matter: null,
            timeSheetId: matterChangeState.draftInvoice?.timeSheetId
          });
        } else {
          await changeMatterForGroup({
            matterId: matterChangeState.matter.id,
            matter: null,
            timeSheetId: matterChangeState.draftInvoice?.timeSheetId
          });
        }
        emit('cancel');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'An unexpected error occurred while changing the matter. Please try again.';
        handleError(errorMessage);
      } finally {
        // Clear cache when done
        clearCache();
      }
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("Change Matter ", -1)]))]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [matterChangeState.loadingClientMatter ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: 0,
            type: "heading,heading"
          })) : _createCommentVNode("", true), !matterChangeState.loadingClientMatter ? (_openBlock(), _createBlock(ClientMatterSearch, {
            key: 1,
            me: matterChangeState.me,
            emitOnAnyChange: true,
            horizontal: true,
            cm: matterChangeState,
            "query-filter": cmQueryFilter.value,
            "data-cy": "client-matter-search",
            onMatterChange: _cache[1] || (_cache[1] = $event => matterChanged())
          }, null, 8, ["me", "cm", "query-filter"])) : _createCommentVNode("", true), !matterChangeState.loadingDraftInvoiceList && matterChangeState.matter ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(LlSelect, {
            modelValue: matterChangeState.draftInvoice,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => matterChangeState.draftInvoice = $event),
            items: matterChangeState.draftInvoices,
            "item-title": "created",
            "item-value": "timeSheetId",
            density: "compact",
            "return-object": "",
            placeholder: "Select a Draft Invoice",
            variant: "outlined",
            "hide-details": "true",
            label: "Draft Invoice (Optional)",
            clearable: "",
            labelClass: "text-sm at-choose-client remove-outline",
            isAutocomplete: "",
            "data-cy": "draft-select"
          }, null, 8, ["modelValue", "items"])])) : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: 3,
            type: "heading"
          }))]), _createElementVNode("div", _hoisted_3, [matterChangeState.selectionValid && !matterChangeState.hasMissingUsers && !matterChangeState.loadingUserValidation ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Moved time entries will use the hourly rate of the destination matter. ")) : _createCommentVNode("", true), matterChangeState.loadingUserValidation ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: "16",
            class: "mr-2"
          }), _cache[7] || (_cache[7] = _createTextVNode(" Validating if the user exists in the destination matter.. ", -1))])) : matterChangeState.userAddedMessages.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(matterChangeState.userAddedMessages[0]), 1)) : _createCommentVNode("", true), matterChangeState.unableToMoveChargeWithBilledEntries ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Cannot move to this matter because one or more Time Entries associated with this Fixed Fee have been billed to another invoice. ")) : _createCommentVNode("", true)]), _createVNode(LlConfirmationDialog, {
            ref_key: "confirmDialog",
            ref: confirmDialog,
            title: "Move Entry",
            "confirm-text": "Continue",
            "toggle-text": "Cancel",
            message: "Note: You are moving a time entry that is currently associated with a fixed fee on this invoice. By moving just the time entry (or entries) and not the fixed fee, you will disassociate the time entry from the fixed fee. The fixed fee will remain on the invoice."
          }, null, 512)]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            class: "w-100"
          }, {
            prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
              class: "mr-2",
              onBtnClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('cancel'))
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Close ", -1)]))]),
              _: 1
            })]),
            append: _withCtx(() => [_createVNode(LlSecondaryButton, {
              disabled: matterChangeState.unableToMoveChargeWithBilledEntries || matterChangeState.loadingUserValidation,
              color: "primary",
              variant: "flat",
              "data-cy": "save-or-apply",
              onBtnClick: _cache[4] || (_cache[4] = $event => verifyMatterChange())
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(matterChangeState.draftInvoice ? 'Apply' : 'Save For Later'), 1)]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};